import { createContext } from 'react';
import { gtagSnippet } from './gtagSnippet';

export const GTagContext = createContext(gtagSnippet());

export const GTagProvider = GTagContext.Provider;
